/* eslint-disable function-paren-newline */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './containers/App';
import { ConfigProvider } from './config/ConfigProvider';
import configureAppStore from './store';
import { unregister } from './registerServiceWorker';

const store = configureAppStore({});

createRoot(document.getElementById('root')).render(
  <ConfigProvider>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </ConfigProvider>
);

unregister();
export { store };
